import React from 'react'
import moment from 'moment'
import { displayEventLocation } from '../../../../../helpers/eventAddress'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'

const EventInfo = ({ event }) => (
  <Grid item xs={12} md={6} lg={4}>
    <DetailsBox
      title="Event Information"
      singleColumn
      rows={[
        {
          label: 'Start',
          value: moment(event.startDate).format('Do MMM YYYY - HH:mm'),
        },
        {
          label: 'End',
          value: moment(event.endDate).format('Do MMM YYYY - HH:mm'),
        },
        {
          label: 'Description',
          value: event.eventDescription,
        },
        {
          label: 'Location',
          value: displayEventLocation(event),
        },
        {
          label: 'Type',
          value: event.eventType,
        },
      ]}
    >
      {event?.cancellationReason && (
        <DetailRow label="Cancelled" value={event.cancellationReason} />
      )}
      <DetailRow
        label="Medical Plan Approved"
        value={event?.EMPApproved ? 'Yes' : 'No'}
        fullWidthLabel
      />
    </DetailsBox>
  </Grid>
)

export default EventInfo
